import { Flex, Text } from '@modusign/design-system';
import { ReactNode } from 'react';

export default function FieldLocatorBadge({ children }: { children: ReactNode }) {
  return (
    <Flex
      alignItems="center"
      backgroundColor="statusBackgroundNeutralBase"
      borderRadius="10px"
      color="textNeutralLight"
      justifyContent="center"
      minWidth="auto"
    >
      <Text fontSize="xs" fontWeight="medium" px={3} py="2px" sx={{ whiteSpace: 'nowrap' }}>
        {children}
      </Text>
    </Flex>
  );
}
